export default "__VITE_ASSET__C_0aOV17__"